import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import './styles/css/index.css';
import configureStore from './store/configureStore';
//import App from './App';
import PublicRoutes from './containers/PublicRoutes';
import * as serviceWorker from './serviceWorker';
import history from './history';

const store = configureStore();
const rootElement = document.getElementById('root');


ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            {/*<App />*/}
            <PublicRoutes />
        </Router>
    </Provider>, rootElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
